<template>
    <m-pageframe title="Demos">
        <v-container class="px-4">
            <h1>Select a Demo Experience</h1>

            <v-list>
                <v-list-item-group>
                    <v-list-item
                        v-for="(demo, index) in demo_experiences"
                        :key="index"
                        :to="{ name: demo.route }"
                        link
                    >
                        <v-list-item-avatar>
                            <v-icon
                                large
                                :color="demo.iconColor || 'grey'"
                            >{{ demo.icon }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>{{ demo.title }}</v-list-item-title>
                            <v-list-item-subtitle>{{ demo.description }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-container>
    </m-pageframe>
</template>

<script>
export default {
    name: "DemoSelector",

    data() {
        return {
            demo_experiences: [
                {
                    title: "Guest Check-In",
                    description: "Guest check-in process with a variety of consent gathering strategies.",
                    route: "search-forms-guest-check-in-demo-gateway",
                    icon: "mdi-account-check"
                },
                {
                    title: "Order Confirmation",
                    description: "Order confirmation process with a focus on user consent.",
                    route: "order-confirmation-demo-gateway",
                    icon: "mdi-package-variant-closed"
                },
                {
                    title: "CRM Account Confirmation",
                    description: "Contact information verification via bulk messaging campaign.",
                    route: "crm-account-confirmation-demo-gateway",
                    icon: "mdi-account-details"
                },
            ]
        };
    },
}
</script>

<style lang="scss" scoped>
.container {
    max-width: 75rem;
    margin: 0 auto;
}
</style>